module.exports = __webpack_public_path__ + "img/info-sm-icon.9bfb9904.svg";